import React from "react";
import { useSelector } from "react-redux";
import { PROMOTION_SERVICE_TYPE } from "../employerConstanst";
import { Card, Image } from "semantic-ui-react";
import {
  getItemExpiredDate,
  getItemPublishedDate,
  getPromotionPurchasedDate,
} from "../../../js/helpers/getItemDisplayDate";
import { getJobExpiringStatus } from "../../../js/helpers/getDaysBetweenTwoDates";

export default function PromotionServiceListItem({
  item,
  promotionType,
  promotionItemType,
  isAdmin,
}) {
  const { responsive } = useSelector((state) => state.app);

  function getItemDisplayDate() {
    if (promotionType === PROMOTION_SERVICE_TYPE.expired) {
      return getItemExpiredDate(item);
    } else if (promotionType === PROMOTION_SERVICE_TYPE.underReview) {
      return getPromotionPurchasedDate(item);
    } else if (promotionType === PROMOTION_SERVICE_TYPE.active) {
      return (
        <div style={{ marginTop: 6 }}>
          {getItemPublishedDate(item)}
          <br />
          {getJobExpiringStatus({
            date: item.dateExpiring,
            show: true,
            showClock: false,
          })}
        </div>
      );
    }
  }

  return (
    <Card style={{ width: !responsive.isMobile ? "29%" : "45%" }} key={item.id}>
      {isAdmin && (
        <Card.Content textAlign="center">
          <div style={{ fontSize: 11 }}>ID: {item.id}</div>
          <div style={{ fontSize: 11 }}>Emp: {item.employerId}</div>
          <div style={{ fontSize: 11 }}>PI Id: {item.paymentIntentId}</div>
        </Card.Content>
      )}
      <Card.Content textAlign="center">
        <Image size="small" src={item.featuredCompanyLogoURL} />
      </Card.Content>
      <Card.Content>
        <div className="body-blue-text semi-bold">{promotionItemType}</div>
        <div className="body-blue-text">
          {getItemDisplayDate()}{" "}
          {item.isFree && <span className="accent-colour">(Free)</span>}
        </div>
      </Card.Content>
    </Card>
  );
}
